import { Button } from "@/components/ui/button";
import { toast } from "@/components/ui/use-toast";
import { SelecaoCompraGiro } from "@/components/CompraRapidaGiro";
import { DadosResumoGiro } from "@/dtos/Request/FinalizarCompraSorteioGiroDto";
import { FormasPagamento } from "@/dtos/FormasPagamento";
import { QrCodeGeradoDto } from "@/dtos/QrCodeGeradoDto";
import AppService from "@/services/AppService";
import CompraService from "@/services/CompraService";
import { PresenteadoDto } from "@/services/AcessoService";
import StorageUtils from "@/utils/StorageUtils";
import { montarPayloadSorteioGiro } from "@/utils/montarPayloadSorteioGiro";
import { clearSelecaoGiroCheckout } from "@/utils/selecaoGiroCheckout";
import { DrawerPagamentoParaOutraPessoa } from "@/pages/FinalizarCompra/DrawerPagamentoParaOutraPessoa";
import { FinalizarCompraTermos } from "@/pages/FinalizarCompra/FinalizarCompraTermos";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FinalizarCompraGiroResumo } from "./FinalizarCompraGiroResumo";

interface FinalizarCompraGiroPixProps {
    dadosResumo: DadosResumoGiro;
    selecao: SelecaoCompraGiro;
    token?: string;
    presenteados: PresenteadoDto[];
    handlePresenteados: (action: "remove" | "load", presenteado?: PresenteadoDto) => void;
}

export function FinalizarCompraGiroPix({
    dadosResumo,
    selecao,
    token,
    presenteados,
    handlePresenteados,
}: FinalizarCompraGiroPixProps) {
    const [termosAceito, setTermosAceito] = useState(false);
    const [realizandoPagamento, setRealizandoPagamento] = useState(false);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    async function handleFinalizarCompra() {
        try {
            setRealizandoPagamento(true);

            let idPresenteado: number | undefined;
            const getIdPessoaPresenteada = searchParams.get("idPessoaPresenteada");
            if (getIdPessoaPresenteada) {
                idPresenteado = Number(getIdPessoaPresenteada);
            }

            const payload = montarPayloadSorteioGiro(selecao, {
                Origem: token ? "IOS" : "Web",
                FormaPagamento: FormasPagamento.Pix,
                IdentificadorDispositivo: await StorageUtils.getDispositivo(),
                IdPresenteado: idPresenteado,
                IdVendedor: StorageUtils.getIdVendedor(),
            });

            let result: QrCodeGeradoDto;

            if (token) {
                const { Data } = await AppService.FinalizarCompraSorteioGiroPixApp(payload, token);
                result = Data;
            } else {
                const { Data } = await CompraService.FinalizarCompraSorteioGiroPix(payload);
                result = Data;
            }

            toast({
                variant: "success",
                description: "QRCode gerado com sucesso!",
                duration: 4000,
            });

            clearSelecaoGiroCheckout();
            StorageUtils.removeIdVendedor();

            let urlNavigate = "/compra/finalizar/giro/qrcode";
            if (token) {
                urlNavigate += "?origem=ios";
            }

            await navigate(urlNavigate, { state: { ...result } as QrCodeGeradoDto });
        } catch (error: unknown) {
            setRealizandoPagamento(false);
            toast({
                variant: "destructive",
                description: String(error),
                duration: 4000,
            });
        }
    }

    return (
        <div className="md:w-5/12">
            <div className="flex flex-col md:flex-row">
                <FinalizarCompraGiroResumo dadosResumo={dadosResumo} />
            </div>
            <div className="flex flex-col gap-5">
                <DrawerPagamentoParaOutraPessoa
                    handlePresenteados={handlePresenteados}
                    presenteados={presenteados}
                />
                <FinalizarCompraTermos
                    aceitarTermos={async (termos) => setTermosAceito(termos)}
                    termosAceito={termosAceito}
                />
                <Button
                    className="w-full"
                    size="xl"
                    disabled={!termosAceito || realizandoPagamento}
                    onClick={handleFinalizarCompra}
                    variant="default"
                >
                    {realizandoPagamento ? "Realizando Pagamento..." : "Pagar com PIX"}
                </Button>
            </div>
        </div>
    );
}
